import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommonApiService } from '../../common-api.service';
import { MODULE_ACCESS_OPTIONS } from '../module-access.constants';
import { UserRole } from './userrole.interface';
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { Router } from '@angular/router';
import { SnackbarService } from '../../snackbar.service';

@Component({
    selector: 'app-userrole.form',
    templateUrl: './userrole.form.component.html',
    styleUrls: ['./userrole.form.component.css']
})
export class UserRoleFormComponent implements OnInit {
    constructor(
        private route: ActivatedRoute,
        private api: CommonApiService,
        private router: Router,
        public dialog: MatDialog,
        private snackbar: SnackbarService,
    ) { }

    public model = 'userrole'
    public userrole = {} as UserRole;
    isFormDisabled = true;
    result: string;

    // Access control
    modules = MODULE_ACCESS_OPTIONS;
    modules_selected: string[] = [];

    ngOnInit() {
        let roleId = this.route.snapshot.params.id
        if (roleId === 'create') {
            console.log('False')
            this.isFormDisabled = false;
        }
        else {
            this.getRoles(Number(roleId));
        }
    }

    getRoles(roleId: number) {
        this.api.get(this.model, roleId).subscribe(
            (data: any) => {
                if (data) {
                    this.userrole = data;
                    // Filter out stale module names that no longer exist in MODULES
                    const validNames = this.modules.map(m => m.name);
                    this.modules_selected = (data.access || []).filter((a: string) => validNames.includes(a));
                }
            }
        );
    }

    save(formValid: any) {
        if (formValid == false) {
            this.snackbar.warning('Please fill mandatory fields.');
            return;
        }
        this.api.createUpdate(this.model, this.userrole).subscribe(
            (data: any) => {
                if (data) {
                    this.userrole = data;
                    this.isFormDisabled = true;
                    if (this.userrole.id) {
                        this.saveAccess();
                    } else {
                        this.snackbar.success('Saved Successfully!');
                    }
                }
            },
            error => {
                this.snackbar.error(error.error.message);
            }
        );
    }

    saveAccess() {
        const data = {
            userrole_id: this.userrole.id,
            modules: this.modules_selected,
        };
        this.api.callRoute('userrole', '/access/update', data).subscribe(
            (res: any) => {
                if (res) {
                    this.snackbar.success('Role and permissions saved successfully');
                }
            },
            error => {
                this.snackbar.error('Role saved but failed to update permissions');
            }
        );
    }

    edit(){
        this.isFormDisabled = false;
    }

    discardChanges(): void {
		const message = `Are you sure you want to discard the changes?`
		const dialogConfig = new MatDialogConfig();
		dialogConfig.data = {
			title: "Discard Changes",
			message: message
		}
		const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);
		dialogRef.afterClosed().subscribe(dialogResult => {
			this.result = dialogResult;
			// return true or false or undefined , hence we can handle the functionality on true and false likewise here
			if (this.result) {
                if(this.userrole.id){
                    this.isFormDisabled = true;
                    this.getRoles(this.userrole.id);
                }else{
                    this.router.navigate([`/userrole`]);
                }
			}
		});
	}

    create(){
        this.redirectTo('userrole/create');
    }

    //redirects to the expected route
    //this function will redirect to a dummy route and quickly return to the destination route without the user realizing it.
    redirectTo(uri:string){  
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=>
        this.router.navigate([uri]));
    }

    // Access control methods
    isModuleEnabled(moduleName: string): boolean {
        return this.modules_selected.includes(moduleName);
    }

    onToggleModule(moduleName: string, event: any): void {
        if (event.checked) {
            if (!this.modules_selected.includes(moduleName)) {
                this.modules_selected.push(moduleName);
            }
        } else {
            this.modules_selected = this.modules_selected.filter((m) => m !== moduleName);
        }
    }

    toggleAll(event: any): void {
        if (event.checked) {
            this.modules_selected = this.modules.map((m) => m.name);
        } else {
            this.modules_selected = [];
        }
    }

    get allSelected(): boolean {
        return this.modules.length > 0 && this.modules_selected.length === this.modules.length;
    }

    get someSelected(): boolean {
        return this.modules_selected.length > 0 && this.modules_selected.length < this.modules.length;
    }

}
